module.exports = __webpack_public_path__ + "static/media/invoice_template_with_professional_fee_description_groups.35976662.docx";